import styled from "styled-components";

const Container = styled.div`
  .MuiDataGrid-cell p {
    margin: 0;
  }

  .tiptap.ProseMirror {
    font-size: inherit;
  }
  .MuiDataGrid-pinnedColumnHeaders {
    box-shadow: none !important;
    padding-top : 5px;
  }
`;

export { Container };
